<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Receiving Form
                <div class="card-header-actions">
                <button  v-if="(model.isposted==0)" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.RecivNo" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.RecivDate" type="date" :max="maxDateReceive"  :state="!$v.model.RecivDate.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-form-row>
                        <b-col md="6">
                            <b-input-group >
                                <b-input-group-prepend><label>PO/SO No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.orderno" :state="!$v.model.orderno.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuPorderShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Note/Description</label></b-input-group-prepend>
                        <b-form-input v-model="model.Note"  placeholder="Note/Description" ></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col>
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor.$error"></b-form-input>
                    </b-input-group>
                        <b-input-group>
                            <b-input-group-prepend><label>Delivery Doc. No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.DoNumber" ></b-form-input>
                        </b-input-group>
                        <b-input-group>
                            <b-input-group-prepend><label>Delivery Doc. Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.Dodate" type="date" ></b-form-input>                                        
                        </b-input-group>
                </b-col>
              </b-row>
              
                <div class="report-wraper">
                    <table style="width: 99%;">
                        <thead>
                            <tr>
                                <th width="20px">No.</th>
                                <th width="180px">Item Code</th>
                                <th width="300px">Item Name</th>
                                <th >Description</th>
                                <th width="100px">Outstand<br>Quantity</th>
                                <th width="200px">Received<br>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in ordLines.items" :key="row.podtlkey">
                                <td>{{idx+1}}</td>
                                <td>{{row.partnumber}}</td>
                                <td>{{row.itemname}}</td>
                                <td>{{row.description}}</td>
                                <td  style="text-align:center;">{{row.OstQtyRcvB4}} {{row.unitsize}}</td>
                                <td style="text-align:center;">
                                    <b-input-group>
                                        <b-form-input v-model="row.quantity"  type="number" :min="0" ></b-form-input>
                                        <b-input-group-append><span class="input-group-text">{{row.unitsize}}</span></b-input-group-append>
                                    </b-input-group>
                                </td>
                                <!-- <td v-else style="text-align:center;">{{row.quantity}} {{row.unitsize}}</td> -->
                            </tr>
                        </tbody>
                    </table>                    
                </div>                  
            <b-row class="justify-content-center mt-1">
                <button class="btn btn-primary" @click="close()" v-if="(model.isposted==1)"> <i class="fa fa-close"></i> Close</button>
                <div style="width:450px;" v-if="(model.isposted==0)">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>

            </b-row>

        </b-card>
        <b-modal v-model="lkuPorderShow" size="lg" :hide-footer="true" title="List of APPROVED Purchase/Service Order " :centered="true">
            <lku-porder @click="onSelectLkuPorder" :where="wherePorder"></lku-porder>
        </b-modal>       
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">

    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuPorder from "../lookup/lkuPorder.1";
import procreceiv from "../../apis/procreceiv";
import procure from "../../apis/procure";
// import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, lkuPorder},
  mixins: [validationMixin],
  validations: {
        model: {
            RecivDate: { required },
            vendor: { required },
            orderno: { required },
            remark: { required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
          isLoading:false,
        inputBerlanjut:0,
        lkuPorderShow:false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        maxDateReceive:moment(new Date()).format('YYYY-MM-DD'),
        uanguser: this.$store.state.user.matauang,
        model:{jasa:0, isposted:0,
            matauang:this.$store.state.user.matauang, 
            compcode:this.$store.state.user.compcode,
            vendor:'',orderno:'',kodecash:'', paymterm:'', terms:[], namaClsDoc:'STANDARD', 
            locationdeliv:this.$store.state.user.compaddr},
        ordLines: {
            items: [],
        },
        wherePorder:{
            status:'111',
            outstand:1,
        }
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidOrdLines() {
    //   this.ordLines.kenappn= (this.ordLines.ppn != 0); 
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
    //   this.postGroups = [];
    //   this.postGroups = await procreceiv.postgroup();
      
    //   this.lookupPPH = await procreceiv.pasalpph();
    //   this.currency = await procreceiv.currency();
    //   this.paymentTerms = await procreceiv.paymterms();

    if (this.$route.params.RecivKey)  {
          toastr.info('Loading Order Detail, please wait')
          try {
            const data = await procreceiv.detail(this.$route.params);  
            const row = data[0][0];
            // console.log('row',row)
            // this.saveEnabled=(row.send2wf === 0);
            row.RecivDate = row.RecivDate ? moment(row.RecivDate).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            // console.log('data[1]',data[1])
            data[1].forEach(element => {
                element.OstQtyRcvB4 = element.OstQtyRcvB4 || (element.quantity-(element.qtyreceived || 0));
                element.toleransi = element.toleransi || 0;
                this.ordLines.items.push(element)
            });
            // this.model.terms = data[2];
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.RecivDate  = moment().format('YYYY-MM-DD');
        }
  },
  methods: {
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            this.isLoading=true;            
            try {
                // this.model.TableName = 'po_receipt_header';
                // const dimValResult = await dimension.validate(this.model);
                // console.log('dimValResult',dimValResult)
                // if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.RecivKey = this.model.RecivKey || '';
                    this.model.RecivNo = this.model.RecivNo || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.terms = this.model.terms;
                    row.RecivDate = moment(row.RecivDate).format('YYYY-MM-DD');
                    // row.DoDate = moment(row.DoDate).format('YYYY-MM-DD');
                    row.DoDate = row.DoDate ? moment(row.DoDate).format('YYYY-MM-DD') : '';
                    let lineno=1;
                    let lineError=false;
                    row.lines = this.ordLines.items.reduce((newArr, item) => {
                        if (item.itemno || '')  {
                            if (item.OstQtyRcvB4 >= item.quantity) {
                                item.lineno = lineno;
                                newArr.push(item);
                                lineno += 1;
                                if (item.quantity<item.QtyPO) {
                                    console.log(`${item.partnumber} | ${item.itemnam},  qtyReceving < QtyPO : `, item.quantity,item.QtyPO);
                                    this.model.partialRcv=1;
                                }                                            
                            } else {
                                if (item.toleransi>0) {
                                    if ((item.OstQtyRcvB4 +item.toleransi) >= item.quantity) {
                                            item.lineno = lineno;
                                            newArr.push(item);
                                            lineno += 1;

                                    } else {
                                        toastr.error(`Qty. Received '${item.itemname}' exceed Qty. Ordered is not allowed. Tolerant Qty is only ${item.toleransi}`)
                                        lineError=true;
                                    }                                    
                                } else {
                                    toastr.error(`Qty. Received '${item.itemname}' exceed Qty. Ordered is not allowed. Pleace check the master item's tolerant Qty`);
                                        lineError=true;
                                }
                            }
                        }
                        return newArr;
                    }, []);
                    if (lineError) {
                        this.isLoading=false;            
                    } else {
                        if (row.lines.length>0) {
                            if (this.ordLines.items.length !== row.lines.length) {
                                this.model.partialRcv=1;
                            } 

                            // await procreceiv.insert(row);
                            // toastr.success("Complete successfully", "Save Order");
                            const hasil= await procreceiv.insert(row);
                            toastr.success(`Success, Trx.Number ${hasil.RecivNo}`, "Save Receiving",10000);
                            this.isLoading=false;            
                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                const tanggal = this.model.RecivDate;
                                for (var key in this.model) {
                                    this.model[key] = '';
                                }
                                this.model.RecivDate = tanggal;
                                this.ordLines.items=[];
                                this.$v.model.$reset();                        

                            }
                        } else {
                            this.isLoading=false;            
                            toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                        }
                    }
                // } else {
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE");
                // }
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Order Error");                
            }

        }
    },
    onSelectLkuPorder:async function (_selected) {
        // Note : apakah bisa masukkan PO lebih dari 1?
        if ((this.model.po) && (this.model.po !== _selected.orderno)) {
            toastr.error('Select other PO','ERROR MESSAGE',10000);
        } else {
            this.model.pohdrkey = _selected.pohdrkey;
            this.model.po = _selected.orderno;
            this.model.vendor = _selected.vendor;
            this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
            this.model.postgroup = (_selected.postgrp || '').trim();
            this.model.matauang = _selected.matauang;
            this.model.totalinv = _selected.nilaidue;
            this.model.chargeable = _selected.chargeable;
            this.model.nilaidpp = _selected.dpp;
            this.model.nilaippn = _selected.nilaippn;
            this.model.DimTableKey = _selected.DimTableKey;
            try { 
                const data = await procure.detail({ pohdrkey: _selected.pohdrkey }) ;
                // console.log('Po Detail ; ', data);
                this.ordLines.items =[];
                const row = data[0][0];
                for (var key in row) {
                    this.model[key] = row[key];
                }

                data[1].forEach(element => {
                    element.OstQtyRcvB4 = element.quantity - element.qtyreceived ;
                    element.toleransi = element.toleransi || 0;
                    // element.OstQtyRcvB4 = element.QtyPO - element.qtyProcGCIF
                    this.ordLines.items.push(element)
                });


            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        
        }
        this.lkuPorderShow=false;
        
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.receivingfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
